'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SocialBlock = function SocialBlock(props) {
  var bgWhite = props.bgWhite,
      className = props.className,
      collapse = props.collapse,
      dividerBottom = props.dividerBottom,
      dividerTop = props.dividerTop,
      emailSubject = props.emailSubject,
      header = props.header,
      shareLink = props.shareLink;

  var _useState = React.useState(false),
      _useState2 = slicedToArray['default'](_useState, 2),
      showSocial = _useState2[0],
      setShowSocial = _useState2[1];

  var classes = index['default']('social-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', header && 'padding-bottom', className);
  var ulClasses = index['default']('social-block-list', className);
  var liClasses = index['default']('social-block-list-item', bgWhite && 'social-list-item-white', collapse && !showSocial && 'social-block-collapse');

  var renderCollapse = function renderCollapse() {
    var moreSocialClasses = index['default']('social-block-list-item', 'more-social', bgWhite && 'social-list-item-white');
    return collapse ? /*#__PURE__*/React__default['default'].createElement("li", {
      className: moreSocialClasses
    }, /*#__PURE__*/React__default['default'].createElement("button", {
      onClick: function onClick() {
        return setShowSocial(!showSocial);
      },
      type: "button",
      "aria-label": "open"
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: "fa fa-ellipsis-h",
      "aria-hidden": "true"
    }))) : null;
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-socialblock"
  }, header && /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "sidebar-header"
  }, header), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: ulClasses
  }, /*#__PURE__*/React__default['default'].createElement("li", {
    className: liClasses + ' show'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(shareLink)),
    type: "button",
    "aria-label": "Go to Facebook"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fab fa-facebook-f",
    "aria-hidden": "true"
  }))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: liClasses
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://twitter.com/intent/tweet?url=".concat(encodeURIComponent(shareLink), "&text="),
    type: "button",
    "aria-label": "Go to Twitter"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fab fa-twitter",
    "aria-hidden": "true"
  }))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: liClasses
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "http://www.linkedin.com/shareArticle?mini=true&url=".concat(encodeURIComponent(shareLink), "&title="),
    type: "button",
    "aria-label": "Go to Linkedin"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fab fa-linkedin",
    "aria-hidden": "true"
  }))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: liClasses
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://pinterest.com/pin/create/button/?url=".concat(encodeURIComponent(shareLink), "&media=&description="),
    type: "button",
    "aria-label": "Go to Pinterest"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fab fa-pinterest",
    "aria-hidden": "true"
  }))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: liClasses + ' show'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "mailto:?subject=".concat(emailSubject, "&body=Check out this article I found on Los Alamos National Laboratory's website: ").concat(shareLink),
    type: "button",
    "aria-label": "Go to mail"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fa fa-envelope",
    "aria-hidden": "true"
  }))), /*#__PURE__*/React__default['default'].createElement("li", {
    className: liClasses + ' print-btn'
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    onClick: function onClick() {
      return window.print();
    },
    type: "button",
    "aria-label": "Print"
  }, /*#__PURE__*/React__default['default'].createElement("i", {
    className: "fa fa-print",
    "aria-hidden": "true"
  }))), renderCollapse()));
};

SocialBlock.defaultProps = {
  bgWhite: false,
  collapse: false,
  dividerBottom: false,
  dividerTop: false
};
SocialBlock.propTypes = {
  emailSubject: PropTypes__default['default'].string.isRequired,
  shareLink: PropTypes__default['default'].string.isRequired,
  bgWhite: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string,
  collapse: PropTypes__default['default'].bool,
  dividerBottom: PropTypes__default['default'].bool,
  dividerTop: PropTypes__default['default'].bool,
  header: PropTypes__default['default'].string
};
exports.SocialBlock = SocialBlock;
exports['default'] = SocialBlock;